<section>
    <header class="row page-header">
        <div class="col-sm-12">
            <h2 class="title pull-left">Welcome to SmartProperty</h2>
            <!-- Hiding create property as part of WEB-2283 -->
            <!-- <div class="controls pull-right">
                <button *spHasRole="['Admin', 'Manager', 'PortfolioAdmin']" class="btn btn-success" (click)="addProperty.onShow()"> Create New Property</button>
            </div> -->
        </div>
    </header>

    <main>
        <sp-add-property #addProperty></sp-add-property>

        <sp-property-filter
            [propertyFilterSettings]="propertyFilterSettings$ | async"
            [propertyTypes]="propertyTypes$ | async"
            [isActiveFilterEnabled]="false"
            (filterChanged)="onFilterChanged($event)">
        </sp-property-filter>

        <sp-user-property-list
            [propertySearchResult]="propertySearchResult$ | async"
            [hasProperties]="hasProperties$ | async"
            [isLogin]="isLogin"
            [selectedPropertyId]="selectedPropertyId$ | async"
            (archive)="onArchive($event)"
            (pageChanged)="onPageChanged($event)"
            (showDialog)="addProperty.onShow()"
            [userProfile]="userProfile$ | async"
            >
        </sp-user-property-list>
    </main>
</section>
